// Module
var code = "<div class=\"vui-screen-pages\">\n    <div class=\"vui-screen-pages__content\" ng-transclude=\"contents\"></div>\n</div>\n";
// Exports
module.exports = code;